<section class="banner-wrapper">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12">
        <div class="wrapper-content">
          <h1>Пробные тесты ОРТ</h1>
          <p>Максимально приближённые тесты к ОРТ, подробный и детальный анализ тестов.</p>
        </div>
      </div>

      <div class="col-lg-6 col-md-12">
        <div class="banner-courses-category">
          <ul>
            <li>
              <a>
                <i class='bx bx-detail'></i>
                Основные тесты
              </a>
            </li>

            <li>
              <a routerLink="/coming-soon">
                <i class='bx bx-shape-triangle'></i>
                Математика
              </a>
            </li>

            <li>
              <a routerLink="/coming-soon">
                <i class='bx bxs-book-bookmark'></i>
                Русский язык
              </a>
            </li>

            <li>
              <a>
                <i class='bx bx-news'></i>
                Предм-е тесты
              </a>
            </li>

            <li>
              <a routerLink="/coming-soon">
                <i class='bx bx-shape-circle'></i>
                Физика
              </a>
            </li>

            <li>
              <a routerLink="/coming-soon">
                <i class='bx bx-test-tube'></i>
                Химия
              </a>
            </li>

            <li>
              <a routerLink="/coming-soon">
                <i class='bx bxl-trello'></i>
                Биология
              </a>
            </li>

            <li>
              <a routerLink="/coming-soon">
                <i class='bx bx-history'></i>
                История
              </a>
            </li>

            <li>
              <a routerLink="/coming-soon">
                <i class='bx bx-font-family'></i>
                Английский
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
